<script>
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';
    import EmptyState from '@itslearning/prometheus/assets/nodes/EmptyState/v1/EmptyState.svelte';
    import Link from "@itslearning/prometheus/assets/Navigation/Link/v1/Link.svelte";
    import ProgressBar from '../ProgressBar/ProgressBar.svelte';
    import QuestionResult from '../QuestionResult/QuestionResult.svelte';
    import LoadingSpinner from '@itslearning/prometheus/assets/nodes/LoadingSpinner/v1/LoadingSpinner.svelte';
    import {txt} from '../../i18n/i18n';
    import {questions, navigation} from '../../stores';
    import {getResults, getResultsAsFile} from '../../api';
    import {ResultSummary} from '../../models/ResultSummary';
    import MatrixQuestionSummary from '../MatrixQuestionSummary/MatrixQuestionSummary.svelte';
      
    /** @param {ResultSummary} results - results for all questions */
    let resultSummary;
    let showErrorMessage = false;
    let isDownloadingFile = false;
    let message = { text: txt('Unknown_error'), type: 'warning' };

    $: if ($navigation.viewTabId === 'tabResultSummary') {
        getData();
    }
       
    async function getData() {
        try {
            let result = await getResults();
            resultSummary = new ResultSummary($questions, result.numberOfCompletedAnswers, result.questionResults);
            showErrorMessage = false;
        } 
        catch {
            showErrorMessage = true;
        }
    }
    
    function getPercent(num, total) {
        if (!total || total <= 0) {
            return 0;
        }

        return Math.round((num * 100) / total);
    }

    function numAnswersText(questionResult) {
        return txt('Number_responded_x', [questionResult.numberOfAnswers]);
    }

    async function getFile(){
        try{
            if (isDownloadingFile) {
                return;
            }
            isDownloadingFile = true;            
            const response = await getResultsAsFile();
            const a = document.createElement('a');
            a.setAttribute('href', response.url);
            a.setAttribute('download', response.filename);
            a.click();
            showErrorMessage = false;
            await new Promise(r => setTimeout(r, 5000));
            isDownloadingFile = false;
        } catch {
            showErrorMessage = true;
        }
    }

</script>


<Banner visible={showErrorMessage} close={txt('Close')} type={message.type} text={message.text}></Banner>
   
{#if !resultSummary}
    {#if !showErrorMessage}
    <div class="spinner">
        <LoadingSpinner size="large" visible={true}/>
    </div>
    {/if}
{:else}
    {#if resultSummary.numberOfCompletedAnswers === 0}
        <EmptyState title={txt('Empty_state_no_responses_heading')} description={txt('Empty_state_no_responses_text')} iconName="test-results" />
    {:else}
        <Link href="#download" iconClass="excel-link" kind="standalone" on:click={getFile} text="{txt('Download_responses')}" />
        <div class="results-summary_info">{txt('Number_of_respondents_x', [resultSummary.numberOfCompletedAnswers]) }</div>
        {#each resultSummary.questionResults as q, i}
            <QuestionResult question={q} number={i + 1}>
                {#if q.type === 'MultipleChoice'}
                    <div>{numAnswersText(q)}</div>
                    <ul class="results-summary__list">
                        {#each q.alternatives as alt}
                            <li class="results-summary__list_item">
                                <div>{alt.text}</div>
                                <span>{txt('Responses_x', [alt.numberOfAnswers])}</span>
                                <ProgressBar percent={getPercent(alt.numberOfAnswers, q.numberOfAnswers)}></ProgressBar>
                            </li>
                        {/each}
                    </ul>
                {:else if q.type === 'Matrix'}
                    <MatrixQuestionSummary question={q} />
                {:else if q.type === 'Open'}
                    <div>{numAnswersText(q)}</div>
                    <ul class="results-summary__list">
                        {#each q.texts as text}
                            <li class="user-content">{text}</li>
                        {/each}
                    </ul>
                {:else if q.type === 'YesNo'}
                    <div>{numAnswersText(q)}</div>
                    <ul class="results-summary__list">
                        <li class="results-summary__list_item">
                            <div>{txt('Yes')}</div>
                            <span>{txt('Responses_x', [q.numberOfYesAnswers])}</span>
                            <ProgressBar percent={getPercent(q.numberOfYesAnswers, q.numberOfAnswers)}></ProgressBar>
                        </li>
                        <li class="results-summary__list_item">
                            <div>{txt('No')}</div>
                            <span>{txt('Responses_x', [q.numberOfNoAnswers])}</span>
                            <ProgressBar percent={getPercent(q.numberOfNoAnswers, q.numberOfAnswers)}></ProgressBar>
                        </li>
                    </ul>
                {/if}
            </QuestionResult>
        {/each}
    {/if}
{/if}

